/**
 * Dedicated flow id for a run-through demo against the mock. Pure, so server code
 * (`@/core/env`) and client components (header, dev controls) share it.
 */
export const TEST_FLOW_ID = "test-flow";

/** `enabled` comes from `isTestFlowEnabled()` or `useRuntimeConfig().testFlow`. */
export const isTestFlow = (
	flowId: string | undefined,
	enabled: boolean
): boolean => enabled && flowId === TEST_FLOW_ID;
